import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import MainMobileNav from './layout/navbar/mobile';
import SecondaryMobileNav from './layout/navbar/mobile/secondary-nav';
import NavBar from './layout/navbar/main';
import Main from './layout/main';

import { AuthProvider } from '../context/auth';

class App extends Component {
  state = {
    isAuthenticated: false,
    currentUser: null,
  };

  componentDidMount() {
    const currentUser = localStorage.getItem('current-user');
    const token = localStorage.getItem('quora-token');

    if (token && currentUser) {
      this.setState({
        isAuthenticated: true,
        currentUser: JSON.parse(currentUser)
      })
    }
  }

  handleAuthentication = (isAuthenticated, currentUser) =>
    this.setState({
      isAuthenticated,
      currentUser,
    });

  render() {
    const { isAuthenticated, currentUser } = this.state;
    const {
      location: { pathname },
    } = this.props;

    return (
      <AuthProvider
        value={{
          isAuthenticated,
          currentUser,
          handleAuthentication: this.handleAuthentication,
        }}
      >
        <>
          {pathname !== '/' && (
            <>
              <NavBar />
              <MainMobileNav />
              <SecondaryMobileNav />
            </>
          )}
          <Main />
        </>
      </AuthProvider>
    );
  }
}

export default withRouter(App);
